import { Link } from "react-router"
import { useDialogState } from "reakit"

import WizardFooter from "../../components/WizardFooter"
import GovtIntroductionNavigatingYourOptionsCard from "./GovtIntroductionNavigatingYourOptionsCard"
import GovtIntroductionWhatYouGetCard from "./GovtIntroductionWhatYouGetCard"
import GovtIntroductionGoalsModal from "./GovtIntroductionGoalsModal"
import GovtIntroductionHowCanNCXHelpYouCard from "./GovtIntroductionHowCanNCXHelpYouCard"
import GovtIntroductionWhoIsNCXCard from "./GovtIntroductionWhoIsNCXCard"

interface GovtWizardContentIntroductionProps {
  handleNext: () => void
}

const GovtWizardContentIntroduction = ({
  handleNext,
}: GovtWizardContentIntroductionProps) => {
  const dialog = useDialogState({ animated: true })

  return (
    <div
      className="pt-10 lg:pt-13 pb-31"
      data-testid="govt-wizard-content-introduction"
    >
      <div className="container w-[784px] max-w-full flex flex-col gap-6 px-5 lg:px-10">
        <div>
          <p className="text-overline">Your NCX Guide</p>

          <h1 className="text-3xl font-display font-medium leading-[124%] tracking-[0.6px] mt-2">
            Secure NRCS funding for your forest
          </h1>
        </div>

        <GovtIntroductionNavigatingYourOptionsCard dialog={dialog} />

        <GovtIntroductionWhatYouGetCard />

        <GovtIntroductionHowCanNCXHelpYouCard />

        <GovtIntroductionWhoIsNCXCard />
      </div>

      <WizardFooter scrollToBottom={false}>
        <div className="w-full sm:w-auto flex flex-col sm:flex-row gap-4 sm:ml-auto">
          <Link
            to="/"
            className="govt-app-page-1-exit-to-dashboard-button btn2 btn2-outline-primary text-center font-bold tracking-[0.32px]"
          >
            Exit to Dashboard
          </Link>

          <button
            type="button"
            className="govt-app-page-1-start-quiz-button btn2 btn2-primary font-bold tracking-[0.32px]"
            onClick={handleNext}
          >
            Start Quiz
          </button>
        </div>
      </WizardFooter>

      <GovtIntroductionGoalsModal dialog={dialog} />
    </div>
  )
}

export default GovtWizardContentIntroduction
